import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Toast} from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'ProTeamMate | Accelerate IT Talent Hiring';

  ngOnInit(): void {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.display = 'none';
    }
    window.onbeforeunload = () => {
      const loader = document.getElementById('app-loader');
      if (loader) {
        loader.style.display = 'flex';
      }
    };
  }

}
